import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { LogOut } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Header() {
  const { logout, user } = useAuth();

  const getHomeRoute = () => {
    return user?.role === 'admin' ? '/admin' : '/leads';
  };

  return (
    <header className="border-b bg-white">
      <div className="flex h-16 items-center px-4 justify-between">
        <Link to={getHomeRoute()} className="flex items-center gap-4">
          <img src="/logo.webp" alt="Logo" className="h-12 w-auto" />
        </Link>
        
        <Button
          variant="ghost"
          size="icon"
          onClick={logout}
          className="text-gray-600 hover:text-gray-900"
        >
          <LogOut className="h-5 w-5" />
          <span className="sr-only">Abmelden</span>
        </Button>
      </div>
    </header>
  );
} 